'use strict';

const { init } = require('../../modules/cookie_consent/frontend/main');

if (document.getElementById('ls-cc-page')) {
  init();
} else {
  window.addEventListener('load', init, { once: true });
}
